import JSONSchemaRenderer from './JSONSchemaRenderer.component';

export default JSONSchemaRenderer;
